<script>
  import Carto from "./Carto.svelte"
  import Resizer from "$lib/components/guardian/Resizer.svelte"
  const defaultGeoJsonStyles = [
    {
      id: "geojson-outline",
      type: "line",
      source: "overlays",
      paint: {
        "line-color": "#1e88e5",
        "line-width": 2,
      },
    },
    {
      id: "geojson-fill",
      type: "fill",
      source: "overlays",
      paint: {
        "fill-color": "#1e88e5",
        "fill-opacity": 0.35,
      },
    },
  ]

  let { name, geoJsonURL = "", geoJsonStyles = defaultGeoJsonStyles } = $props()
</script>

<Resizer atomName="#{name}" />

<Carto
  geoJsonURL={geoJsonURL}
  geoJsonStyles={geoJsonStyles}
  MAP_INTERACTIVE={false}
  center={[162, -24.5]}
  zoom={4.1}
  highlightPoint={{
    coordinates: [166.4572, -22.2758],
    label: "Nouméa",
    color: "#c70000",
    radius: 8,
    minZoom: 0,
    labelMinZoom: 0,
  }}
  extraLabels={[
    {
      coordinates: [165.8, -21.5],
      text: "New Caledonia",
      color: "#000000",
      size: 14,
    },
  ]}
  headline="Making a generic map component"
  subtitle={`Showing some cool stuff`}
  source="Guardian graphic. Source: <a href='https://www.emergency.wa.gov.au/' target='_blank'>EmergencyWA website</a>, OpenStreetMap"
/>

<style lang="scss">
</style>
